import React from 'react'
import PropTypes from 'prop-types'
import MatchProposalModal from '../../../scheduling/MatchProposalModal'

export default function MatchProposalModalWrapper({
  fromLeague,
  leagueId,
  proposalModalOpen,
  setProposalModalOpen,
  selectedOpponent,
  proposedTime,
  availabilityStart,
  availabilityEnd,
  directProposal,
  handleMatchProposalConfirm,
}) {
  if (!fromLeague || !leagueId) {
    return null
  }

  return (
    <MatchProposalModal
      isOpen={proposalModalOpen}
      onClose={() => setProposalModalOpen(false)}
      opponent={selectedOpponent}
      proposedTime={proposedTime}
      availabilityStart={availabilityStart}
      availabilityEnd={availabilityEnd}
      leagueId={leagueId}
      onConfirm={handleMatchProposalConfirm}
      directProposal={directProposal}
    />
  )
}

MatchProposalModalWrapper.propTypes = {
  fromLeague: PropTypes.bool,
  leagueId: PropTypes.number,
  proposalModalOpen: PropTypes.bool.isRequired,
  setProposalModalOpen: PropTypes.func.isRequired,
  selectedOpponent: PropTypes.object,
  proposedTime: PropTypes.string,
  availabilityStart: PropTypes.string,
  availabilityEnd: PropTypes.string,
  directProposal: PropTypes.bool,
  handleMatchProposalConfirm: PropTypes.func.isRequired,
}
